'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _selectors = require('../selectors');

var _Level = require('./Level');

var _Level2 = _interopRequireDefault(_Level);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
   {
     "type": "popular_path",
   }

   The footer module of the All template.

   All of this data is being passed via the front end,
   so no additional attributes are necessary.
 */

function PopularPath(_ref) {
  var moduleClass = _ref.moduleClass,
      levels = _ref.levels,
      start = _ref.start,
      end = _ref.end;

  return _react2.default.createElement(
    'div',
    {
      id: 'tab-popular-path',
      className: 'tab-content type-popular_path ' + moduleClass
    },
    _react2.default.createElement(
      'h2',
      { className: 'heading pointer' },
      _react2.default.createElement(
        'span',
        { className: 'start' },
        start.title
      ),
      _react2.default.createElement(
        'span',
        { className: 'end' },
        end.title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'job-map' },
      _react2.default.createElement(
        'div',
        { className: 'map', id: 'job-map-container' },
        levels.map(function (_ref2, key) {
          var title = _ref2.title,
              _class = _ref2._class,
              columns = _ref2.columns;
          return _react2.default.createElement(_Level2.default, {
            key: key,
            end: end,
            title: title,
            _class: _class,
            columns: columns
          });
        })
      )
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(PopularPath);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/PopularPath/components/PopularPath.jsx
// module id = 1253
// module chunks = 0